/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-aktionen-details/shop.artikel-aktionen-details.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {View} from '../../../../models/view';
import {ShopViewComponent} from '../view/shop.view.component';
import {ArtikelWithAktionen} from '../../../../models/artikel-with-aktionen';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {AppEventService} from '../../../../services/app.event.service';
import {ArtikelAktion} from '../../../../models/artikel-aktion';

/**
 * Zweck: Beschreibt class ShopArtikelAktionenDetailsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'artikel-aktionen-details',
    templateUrl: 'shop.artikel-aktionen-details.component.html',
    styleUrls: ['shop.artikel-aktionen-details.component.scss'],
    standalone: false
})
export class ShopArtikelAktionenDetailsComponent implements OnChanges, OnInit {
  @Input() aktionen: ArtikelWithAktionen;
  @Input() view: View;
  @Input() viewcomp: ShopViewComponent;
  @Input() actions = true;
  @Input() directAddToWarenkorb = false;
  @Input() noWrap = false;
  @Input() showActionDate = true;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private cd: ChangeDetectorRef, public msvc: AppMobileService, private esv: AppEventService) {
  }

/**
 * Beschreibt Methode selectMenge und ihren Rückgabevertrag.
 */
  selectMenge(aktion: ArtikelAktion) {
    this.esv.addGuiEvent('setWkEntryArtikelMenge', {artnr: this.aktionen.artikel.ArtikelNummer, menge: aktion.AbMenge});
  }

/**
 * Beschreibt Methode addMengeDirektInWarenkorb und ihren Rückgabevertrag.
 */
  addMengeDirektInWarenkorb(aktion: ArtikelAktion, event: MouseEvent) {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const origin = rect.width > 0 && rect.height > 0
      ? {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2} : null;
    this.esv.addGuiEvent('addWkEntryArtikelMenge', {
      artnr: this.aktionen.artikel.ArtikelNummer,
      menge: aktion.AbMenge,
      origin
    });
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {

  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {

  }
}
